import request from "@/utils/request";

// 获取报告风险概览
export const getReportOverviewApi = (params) => {
    return request({
        url: "/app/riskReport/getoverView",
        method: "get",
        params
    });
};

// 获取报告饼状图
export const getReportPieDataApi = (params) => {
    return request({
        url: "/app/riskReport/getIndicatorProportion",
        method: "get",
        params
    });
};

//新建或覆盖本期报告，传入bw数据版本的日期 dataVersion
export const buildReportApi = (params) => {
    return request({
        url: "/app/riskReport/buildReport",
        method: "get",
        params,
    })
}

//得到bw的数据版本 新建以及编辑使用
export const getReportBwVersionApi = (params) => {
    return request({
        url: "/app/riskReport/getBwDataVersion",
        method: "get",
        params,
    })
}


//得到发布的数据版本
export const getReportPublishVersionApi = (params) => {
    return request({
        url: "/app/riskReport/getPubDataVersion",
        method: "get",
        params,
    })
}

// 查看往期报告,传发布的数据版本的日期 version
export const getReportPublishDetailApi = (params) => {
    return request({
        url: "/app/riskReport/getPubReport",
        method: "get",
        params,
    })
}

// 查询指定日期版本数据，传入bw数据版本的日期 dataVersion
export const getReportDetailByVeApi = (params) => {
    return request({
        url: "/app/riskReport/getRiskDetailByVersion",
        method: "get",
        params,
    })
}

// 发布报告 传需要发布报告的数据版本 dataVersion
export const publishReportApi = (params) => {
    return request({
        url: "/app/riskReport/issueReport",
        method: "post",
        params,
    })
}

// 编辑风险详情,编辑后保存 riskRequest
export const updateReportApi = (data) => {
    return request({
        url: "/app/riskReport/updateRiskAnalysis",
        method: "post",
        data,
    })
}

// 上传图片
export const uploadReportImgApi = (file, filename) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('imageName', filename);
    return request({
        url: '/app/riskReport/upload',
        method: 'post',
        data: formData,
    });
};

export const getOriginReportDetailApi = (params) => {
    return request({
        url: "/app/riskReport/getOriRiskDetailByVersion",
        method: "get",
        params,
    })
}